import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { HeaderConfigurationToHeader, MENU_HEADER_EVENTS } from './menu-header-events.model';

/**
 * Menu → Header configuration producer.
 *
 * The سایر page opens on its own profile card, so it asks for the app bar to be
 * taken down while it is on screen and puts it back on the way out.
 */
@Service({ autoProvided: false })
export class MenuHeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	private publish(config?: HeaderConfigurationToHeader): void {
		this.eventBus.dispatch(MENU_HEADER_EVENTS.HEADER_CONFIGURATION, config);
	}

	hideHeader(): void {
		this.publish({ visible: false });
	}

	resetHeader(): void {
		this.publish();
	}
}
